import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import './ui/app.css';
import { store } from './data/client.ts';

// Dev only: lets the store be driven from the browser console for measurement.
if (import.meta.env.DEV) (globalThis as unknown as { store: unknown }).store = store;

createRoot(document.getElementById('root')!).render(
  <StrictMode><App /></StrictMode>,
);
